var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import Skeleton from '../../../Skeleton';
var ElementSkeleton = styled(Skeleton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 1.25rem 0;\n  padding: 0.5rem 0;\n  border-radius: 5px;\n  @media only screen and (max-width: 500px) {\n    margin: 1.25rem 0.5rem;\n  }\n"], ["\n  margin: 1.25rem 0;\n  padding: 0.5rem 0;\n  border-radius: 5px;\n  @media only screen and (max-width: 500px) {\n    margin: 1.25rem 0.5rem;\n  }\n"])));
/**
 * This is the detail view skeleton. It provides a skeleton view of the detail view
 * elements until all information is loaded and ready to be displayed. It is available
 * for the desktop as well as the mobile view.
 */
export var InstallmentCalculatorElementSkeleton = function () { return (React.createElement(ElementSkeleton, { height: "7rem" })); };
export default InstallmentCalculatorElementSkeleton;
var templateObject_1;
//# sourceMappingURL=index.js.map